import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import MobileStepper from '@mui/material/MobileStepper';
import { Theme, useTheme } from '@mui/material/styles';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  rootStepper: {
    flexGrow: 1,
  },
}));

export interface HelpSteps {
  title?: string;
  component: React.FunctionComponent;
}

export interface HelpDialogStepperProps {
  title?: string;
  steps: HelpSteps[];
  open: boolean;
  onClose: () => void;
}

export default function HelpDialogStepper(props: HelpDialogStepperProps) {
  const { steps, title, open, onClose } = props;
  const { classes } = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleClose = () => {
    onClose();
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const Component = steps[activeStep].component;

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} fullWidth={true}>
      <DialogTitle id="simple-dialog-title">
        {steps[activeStep].title ?? title ?? 'Help'}
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Component />
      </DialogContent>
      <MobileStepper
        variant="dots"
        steps={steps.length}
        position="static"
        activeStep={activeStep}
        className={classes.rootStepper}
        nextButton={
          activeStep === steps.length - 1 ? (
            <Button size="small" onClick={handleClose}>
              <DoneIcon />
              Done
            </Button>
          ) : (
            <Button size="small" onClick={handleNext} disabled={activeStep === steps.length - 1}>
              Next
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          )
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
        }
      />
    </Dialog>
  );
}
